// @ts-nocheck
import { Component, Input } from '@angular/core';

@Component({
    selector: 'lbca-error-overlay',
    templateUrl: './error-overlay.component.html',
    styleUrl: './error-overlay.component.scss',
    imports: []
})
export class ErrorOverlayComponent {
	public errorlist: string[] = [];

	public dataCss = { arrowDirection: 'top', arrowReference: 'end', arrowColor: 'danger' };

	@Input() set errorData(val: Array<string>) {
		this.errorlist = val;
	}
	@Input() set arrowData(val: any) {
		this.dataCss = val;
	}
}
